import {z} from "../../../../../lib";
import { OperacionCLFBFields } from "./fields";
import {CLFBDetalleInsertSchema} from "./types";

export const schemaOperacionCLFBUpdate = z.object({
    [OperacionCLFBFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCLFBFields.FechaVencimiento]: z.date(),
    [OperacionCLFBFields.AgregadoAbsoluto]: z.number().nullable(),
    [OperacionCLFBFields.AgregadoNeto]: z.number().nullable(),
})

export type OperacionCLFBUpdate = z.infer<typeof schemaOperacionCLFBUpdate>


export const schemaOperacionCLFBInsert = z.object({
    [OperacionCLFBFields.CodPais]: z.number(),
    [OperacionCLFBFields.FechaAprobacion]: z.date().optional().nullable(),
    [OperacionCLFBFields.FechaVencimiento]: z.date(),
    [OperacionCLFBFields.AgregadoAbsoluto]: z.number().nullable(),
    [OperacionCLFBFields.AgregadoNeto]: z.number().nullable(),
    [OperacionCLFBFields.BitEnvio]: z.boolean(),
    [OperacionCLFBFields.ListaDetalles]: z.array(
        CLFBDetalleInsertSchema
    ),
})

export type OperacionCLFBInsert = z.infer<typeof schemaOperacionCLFBInsert>